module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"lock":"Закрытая вакансия. Запись собеседований только по приглашению."}}')
  delete Component.options._Ctor
}
